export const cast = <K>(source: any) => {
    return source as unknown as K;
};

export type KeysEnum<T> = {[P in keyof Required<T>]: true};
